export default "__VITE_ASSET__569561fb__"